import { createGatsbyPageComponent } from '@shapeable/ui';
import { graphql } from 'gatsby';
import { DocumentLayout } from '../../components/entities/document-layout';

export default createGatsbyPageComponent('Document', { layout: DocumentLayout });

export const query = graphql`
query DocumentQuery($id: ID!) {
  platform { document(id: $id) {
    
      id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
    
    type { id name slug __typename }
    content { id text }
    description { id text }
    folder { id name slug }
    owner {
      id name slug path __typename
      openGraph { image { thumbnails { bubble { url url2x } } } }
    }
    files {
      id name slug
      file { id url extension }
    }
    openGraph {
      title
      description { plain }
      image { url url2x thumbnails { card { url url2x } } }
    }
  } }
}

`;
